import type { Getter, Setter } from 'jotai';
import type { AnnotationLabelT } from '../../../../../common/types/types';
import type { UndoRedoActionCommand } from '../../../../../modernization-common/undo-redo/types';
import type { FrameStateT } from '../../../../labelling/types';
import { annotationFramesAtom } from '../../annotation-atoms';
import { STUDIO_WRITE_ACTIONS } from '../../studio-store-write/actions';
import { dispatchStudioStoreWriteAtom } from '../../studio-store-write/dispatch-studio-store-write';
import type { UpdateLabelForAnnotationEventPayload } from '../events';
export const updateLabelForAnnotationCommandFactory = (get: Getter, set: Setter): UndoRedoActionCommand<UpdateLabelForAnnotationEventPayload, void> => {
  let previousAnnotationLabel: AnnotationLabelT | undefined;
  return {
    execute: payload => {
      const {
        annotationIdx,
        annotationLabel
      } = payload;
      const frames = [...get(annotationFramesAtom)];
      const frameWithAnnotationIdx = frames.find(frame => !!frame.annotationStore[annotationIdx]);
      if (!frameWithAnnotationIdx) {
        return;
      }
      previousAnnotationLabel = frameWithAnnotationIdx.annotationStore[annotationIdx]?.annotationLabel;
      if (!previousAnnotationLabel || previousAnnotationLabel.title === annotationLabel.title) {
        return;
      }
      const updatedFrames = applyUpdate(frames, annotationIdx, annotationLabel);
      set(annotationFramesAtom, updatedFrames);
      set(dispatchStudioStoreWriteAtom, {
        type: STUDIO_WRITE_ACTIONS.UPDATE_METADATA,
        annotationId: annotationIdx,
        partialPayload: {
          labelId: annotationLabel.title,
          answers: undefined,
          dynamicAnswers: undefined
        }
      });
    },
    undo: payload => {
      const {
        annotationIdx
      } = payload;
      if (!previousAnnotationLabel) {
        return;
      }
      const frames = [...get(annotationFramesAtom)];
      const updatedFrames = applyUpdate(frames, annotationIdx, previousAnnotationLabel);
      set(annotationFramesAtom, updatedFrames);
      set(dispatchStudioStoreWriteAtom, {
        type: STUDIO_WRITE_ACTIONS.UPDATE_METADATA,
        annotationId: annotationIdx,
        partialPayload: {
          labelId: previousAnnotationLabel.title
        }
      });
    }
  };
};
const applyUpdate = (frames: FrameStateT[], annotationIdx: string, annotationLabel: AnnotationLabelT): FrameStateT[] => {
  return frames.map(frame => {
    if (!frame.annotationStore[annotationIdx]) {
      return frame;
    }
    const filteredRelationshipStore = frame.relationshipStore ? Object.fromEntries(Object.entries(frame.relationshipStore).filter(([, rel]) => rel.sourceAnnotationId !== annotationIdx && rel.targetAnnotationId !== annotationIdx)) : frame.relationshipStore;
    return {
      ...frame,
      annotationStore: {
        ...frame.annotationStore,
        [annotationIdx]: {
          ...frame.annotationStore[annotationIdx],
          annotationLabel,
          metadata: {
            ...frame.annotationStore[annotationIdx]?.metadata,
            answers: undefined,
            dynamicAnswers: undefined
          }
        }
      },
      relationshipStore: filteredRelationshipStore
    };
  });
};